import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HeroSection() {
  const hotArticle = articles.find((a) => a.isHot) || articles[0];

  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dramatic%20moody%20atmosphere%20with%20warm%20orange%20and%20deep%20crimson%20gradient%20lighting%2C%20abstract%20geometric%20shapes%20floating%20in%20dark%20space%2C%20cinematic%20composition%2C%20modern%20editorial%20aesthetic%2C%20subtle%20texture%2C%20no%20people%2C%20clean%20minimal%20background%20elements%20with%20soft%20glow%20effects&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="51吃瓜网 - 今日吃瓜热点"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16">
            <div className="flex-1 pt-16 md:pt-20">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/90 text-white text-xs font-medium mb-4">
                <i className="ri-fire-line text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
                今日最热
              </span>
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight tracking-tight">
                51吃瓜网
              </h1>
              <p className="mt-3 md:mt-4 text-base md:text-lg text-white/80 max-w-lg leading-relaxed">
                在线吃瓜爆料视频每日更新，覆盖网红、主播、博主反差内容，实时追踪黑料大瓜，吃瓜群众的一手资源核心发布页。
              </p>
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mt-6 md:mt-8">
                <Link
                  to={`/article/${hotArticle.id}`}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
                >
                  查看今日热点
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
                <a
                  href="#download"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all duration-200 whitespace-nowrap"
                >
                  <i className="ri-download-line w-4 h-4 flex items-center justify-center"></i>
                  APP下载
                </a>
              </div>

              <div className="flex items-center gap-6 mt-8 md:mt-10">
                <div className="text-white/90">
                  <span className="text-2xl md:text-3xl font-bold font-heading">580万+</span>
                  <p className="text-xs text-white/50 mt-0.5">日活用户</p>
                </div>
                <div className="w-px h-10 bg-white/20"></div>
                <div className="text-white/90">
                  <span className="text-2xl md:text-3xl font-bold font-heading">12万+</span>
                  <p className="text-xs text-white/50 mt-0.5">爆料内容</p>
                </div>
                <div className="w-px h-10 bg-white/20"></div>
                <div className="text-white/90">
                  <span className="text-2xl md:text-3xl font-bold font-heading">890万+</span>
                  <p className="text-xs text-white/50 mt-0.5">APP下载</p>
                </div>
              </div>
            </div>

            <div className="hidden lg:block w-[420px] xl:w-[480px] flex-shrink-0 self-center">
              <Link to={`/article/${hotArticle.id}`} className="group block">
                <div className="relative rounded-2xl overflow-hidden bg-background-50/10 backdrop-blur-sm border border-white/10 p-4 hover:border-primary-500/40 transition-all duration-300">
                  <div className="relative w-full aspect-[16/10] rounded-xl overflow-hidden">
                    <img
                      src={hotArticle.imageUrl}
                      alt={hotArticle.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-semibold">
                        HOT
                      </span>
                    </div>
                  </div>
                  <div className="mt-3">
                    <h3 className="text-sm font-semibold text-white line-clamp-2 leading-relaxed group-hover:text-primary-300 transition-colors">
                      {hotArticle.title}
                    </h3>
                    <div className="flex items-center gap-3 mt-2 text-xs text-white/50">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                        {(hotArticle.views / 10000).toFixed(1)}万
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-chat-3-line w-3 h-3 flex items-center justify-center"></i>
                        {(hotArticle.comments / 10000).toFixed(1)}万
                      </span>
                      <span>{hotArticle.date}</span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}